export default {
    getBridge: function () {
        return window.$gwtBridge || null;
    },
    getSessionInformation: function () {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.getSessionInformation !== "function") {
            return null;
        }

        try {
            const data = bridge.getSessionInformation();
            return data ? JSON.parse(data) : null;
        } catch (error) {
            console.error("Error parsing session information:", error);
            return null;
        }
    },
    getConfigurations: function () {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.getConfigurations !== "function") {
            return [];
        }

        try {
            const data = bridge.getConfigurations();
            return data ? JSON.parse(data) : [];
        } catch (error) {
            console.error("Error parsing configurations:", error);
            return [];
        }
    },
    getWorkplaces: function () {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.getWorkplaces !== "function") {
            return [];
        }

        try {
            const data = bridge.getWorkplaces();
            return data ? JSON.parse(data) : [];
        } catch (error) {
            console.error("Error parsing workplaces:", error);
            return [];
        }
    },
    getWorkplacesByProfile: function () {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.getWorkplacesByProfile !== "function") {
            return [];
        }

        try {
            const data = bridge.getWorkplacesByProfile();
            return data ? JSON.parse(data) : [];
        } catch (error) {
            console.error("Error parsing workplaces by profile:", error);
            return [];
        }
    },
    getDepartments: function () {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.getDepartments !== "function") {
            return [];
        }

        try {
            const data = bridge.getDepartments();
            return data ? JSON.parse(data) : [];
        } catch (error) {
            console.error("Error parsing departments:", error);
            return [];
        }
    },
    getDepartmentsByProfile: function () {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.getDepartmentsByProfile !== "function") {
            return [];
        }

        try {
            const data = bridge.getDepartmentsByProfile();
            return data ? JSON.parse(data) : [];
        } catch (error) {
            console.error("Error parsing departments by profile:", error);
            return [];
        }
    },
    getProjects: function () {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.getProjects !== "function") {
            return [];
        }

        try {
            const data = bridge.getProjects();
            return data ? JSON.parse(data) : [];
        } catch (error) {
            console.error("Error parsing projects:", error);
            return [];
        }
    },
    getCalendars: function () {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.getCalendars !== "function") {
            return [];
        }

        try {
            const data = bridge.getCalendars();
            return data ? JSON.parse(data) : [];
        } catch (error) {
            console.error("Error parsing calendars:", error);
            return [];
        }
    },
    getIAmPartner: function () {
        return JSON.parse(window.$gwtBridge.getIAmPartner());
    },
    getLegalEntities: function () {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.getLegalEntities !== "function") {
            return [];
        }

        try {
            const data = bridge.getLegalEntities();
            return data ? JSON.parse(data) : [];
        } catch (error) {
            console.error("Error parsing legal entities:", error);
            return [];
        }
    },
    getSessionProfile: function () {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.getSessionProfile !== "function") {
            return null;
        }

        try {
            const data = bridge.getSessionProfile();
            return data ? JSON.parse(data) : null;
        } catch (error) {
            console.error("Error parsing session profile:", error);
            return null;
        }
    },
    newCompany: function () {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.newCompany !== "function") {
            return null;
        }

        try {
            const data = bridge.newCompany();
            return data ? JSON.parse(data) : null;
        } catch (error) {
            console.error("Error parsing new company:", error);
            return null;
        }
    },
    setSessionCompany: function (company) {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.setSessionCompany !== "function") {
            return null;
        }

        return bridge.setSessionCompany(company);
    },
    downloadFile: function (url, fileName) {
        const bridge = this.getBridge();
        if (bridge && typeof bridge.downloadFile === "function") {
            bridge.downloadFile(url, fileName);
        }
    },
    emulateCompany: function (companyId) {
        const bridge = this.getBridge();
        if (bridge && typeof bridge.emulateCompany === "function") {
            bridge.emulateCompany(companyId);
        }
    },
	////////////////////////////////////////////////////////////////////////////
	// VALIDATION UTILS
    validateRange: function (value, minimum, maximum) {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.validateRange !== "function") {
            return false;
        }
		return bridge.validateRange(value, minimum, maximum);
	},
	validateCIFOrDNI: function (countryId, value) {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.validateCIFOrDNI !== "function") {
            return false;
        }
		return bridge.validateCIFOrDNI(countryId, value);
	},
	validatePhone: function (countryId, value) {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.validatePhone !== "function") {
            return false;
        }
		return bridge.validatePhone(countryId, value);
	},
	validatePostalCode: function (countryId, value) {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.validatePostalCode !== "function") {
            return false;
        }
		return bridge.validatePostalCode(countryId, value);
	},
    validateDecimalSeparator: function (value, locale) {
        const bridge = this.getBridge();
        if (!bridge || typeof bridge.validateDecimalSeparator !== "function") {
            return false;
        }
        return bridge.validateDecimalSeparator(value, locale);
    },

	////////////////////////////////////////////////////////////////////////////
	// COMPANY UTILS
	getCompanyPlaceholderNif: function (countryId) {
		return window.$gwtCompanyUtils.getPlaceholderNifcountryId(countryId);
	},
	getCompanyPlaceholderCif: function (countryId) {
		return window.$gwtCompanyUtils.getPlaceholderCif(countryId);
	},
	getCompanyPlaceholderTelf: function (countryId) {
		return window.$gwtCompanyUtils.getPlaceholderTelf(countryId);
	},
	getCompanyPlaceholderCp: function (countryId) {
		return window.$gwtCompanyUtils.getPlaceholderCp(countryId);
	},
	////////////////////////////////////////////////////////////////////////////
    processEvent(mode, type, action, payload) {
        const bridge = this.getBridge();
        if (bridge && typeof bridge.processEvent === "function") {
            bridge.processEvent(mode, type, action, payload);
        }
    },
    showGlobalFilter(show) {
        const bridge = this.getBridge();
        if (bridge && typeof bridge.showGlobalFilter === "function") {
            bridge.showGlobalFilter(show);
        }
    },
    fireEvent(event, payload) {
        const bridge = this.getBridge();
        if (bridge && typeof bridge.fireEvent === "function") {
            bridge.fireEvent(event, payload);
        }
    },
}
